import { render } from "./EducationalPartnersPage.vue?vue&type=template&id=154b3e2b"
import script from "./EducationalPartnersPage.vue?vue&type=script&lang=js"
export * from "./EducationalPartnersPage.vue?vue&type=script&lang=js"

const cssModules = {}
import style0 from "./EducationalPartnersPage.vue?vue&type=style&index=0&id=154b3e2b&lang=scss&module=true"
cssModules["$style"] = style0

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__